import { createContext, useContext } from "react";

import { DecodedTokenData } from "./types";

export interface AuthContextData {
  logged: boolean;
  checking: boolean;
  login: (options?: { register?: boolean }) => void;
  logout: () => Promise<void>;
  userInfo?: DecodedTokenData;
}

const defaultAuthContextData: AuthContextData = {
  logged: false,
  checking: false,
  login: () => {},
  logout: async () => {},
};

export const AuthContext = createContext(defaultAuthContextData);

export const useAuthContext = () => useContext(AuthContext);
